module.exports = __webpack_public_path__ + "static/media/project3.2c6cd676.png";